module.exports = __webpack_public_path__ + "img/1f32a.7bc1ce2.svg";